/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ thing: NonNullable<unknown> }} Wrapped_Period_Share_ScaleInputs */

const en_us2_wrapped_period_share_scale = /** @type {(inputs: Wrapped_Period_Share_ScaleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.thing} Logged on My Pocket Gym.`)
};

const pt_br2_wrapped_period_share_scale = /** @type {(inputs: Wrapped_Period_Share_ScaleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.thing} Registrado no My Pocket Gym.`)
};

const es_419_wrapped_period_share_scale = /** @type {(inputs: Wrapped_Period_Share_ScaleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.thing} Registrado en My Pocket Gym.`)
};

const pt_pt2_wrapped_period_share_scale = /** @type {(inputs: Wrapped_Period_Share_ScaleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.thing} Registado no My Pocket Gym.`)
};

const fr_fr2_wrapped_period_share_scale = /** @type {(inputs: Wrapped_Period_Share_ScaleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.thing} Enregistré sur My Pocket Gym.`)
};

const de_de2_wrapped_period_share_scale = /** @type {(inputs: Wrapped_Period_Share_ScaleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.thing} Eingetragen bei My Pocket Gym.`)
};

const it_it2_wrapped_period_share_scale = /** @type {(inputs: Wrapped_Period_Share_ScaleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.thing} Registrato su My Pocket Gym.`)
};

/**
* | output |
* | --- |
* | "{thing} Logged on My Pocket Gym." |
*
* @param {Wrapped_Period_Share_ScaleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_period_share_scale = /** @type {((inputs: Wrapped_Period_Share_ScaleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Period_Share_ScaleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_period_share_scale(inputs)
	if (locale === "es-419") return es_419_wrapped_period_share_scale(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_period_share_scale(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_period_share_scale(inputs)
	if (locale === "de-DE") return de_de2_wrapped_period_share_scale(inputs)
	if (locale === "it-IT") return it_it2_wrapped_period_share_scale(inputs)
	return en_us2_wrapped_period_share_scale(inputs)
});
export { wrapped_period_share_scale as "wrapped-period.share_scale" }